import React from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { mq } from '@/utils/helpers'
import { desktop, laptop, tablet, mobile } from '@/utils/media'
import Typography from '@/components/common/Typography'
import GhostButton from '@/components/common/GhostButton'

const RecruitEntry = props => (
  <Root>
    <Root_Content theme={props.theme}>
      <Title variant="h1" component="h2" lang="en">ENTRY</Title>
      <Actions>
        <Button to="/recruit/fresh/" component={Link}>新卒採用</Button>
        <Button to="/recruit/career/" component={Link}>中途採用</Button>
      </Actions>
    </Root_Content>
  </Root>
)

export default ThemeConsumer(RecruitEntry)

const Root = styled.div`
`

const Root_Content = styled.div`
  padding: 80px 0;
  background: ${props => props.theme.scale[500]};
  text-align: center;
`

const Title = styled(Typography)`
  text-align: center;
`

const Actions = styled.div`
  display: flex;
  @media ${mq.and(desktop, laptop, tablet)} {
    margin-top: 32px;
    justify-content: center;
  }
  @media ${mq.and(mobile)} {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 24px;
  }
`

const Button = styled(GhostButton)`
  width: 180px;
  @media ${mq.and(desktop, laptop, tablet)} {
    margin: 0 8px;
  }
  @media ${mq.and(mobile)} {
    margin-top: 16px;
  }
`
